module.exports = __webpack_public_path__ + "static/mask-6-4b644aea3468cd1bf47da79ca8ecfcb6.png";